import { connectCurrentRefinements, connectGeoSearch } from 'instantsearch.js/es/connectors';

function loadGoogleMapsApi(){
	let local = this;
	let googleMapsApi = document.createElement("script");
	googleMapsApi.async = true;
	googleMapsApi.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + window.bhs.googleMapsApiKey + "&callback=Function.prototype");
	document.body.appendChild(googleMapsApi);
	googleMapsApi.addEventListener('load', function() {
		// local.init();
	});
}

// const makeWidget = connectGeoSearch(renderer, () =>
// 	render(null, containerNode)
// );

export const radiusList = (options, refine) => {
	console.log(options);
	if (!options.container) {
		throw new Error('radiusList: usage: radiusList({container, ...})');
	}
	var $container = document.querySelector(options.container);
	if ($container.length === 0) {
		throw new Error('radiusList: cannot select \'' + options.container + '\'');
	}
	loadGoogleMapsApi();

	return {
		lastGeoLocation: "",
		lastGeoQuery: "",
		ranges: [10, 50, 100, 200],
		selected: "",

		init: function (args) {
			//start off with centering around pittsfield
			// if(args.state.query !== ""){
			// 	args.helper.setQueryParameter('aroundLatLng', "42.4595633, -73.2493172");
			// 	args.helper.setQueryParameter('aroundRadius', parseInt(3000*1609.34));//2000 miles
			// }

			var html = '';
			for(let i = 0 ; i < this.ranges.length; i++){
				html += '<li class="checkbox item " data-value="Within '+this.ranges[i]+' Miles" data-radius="'+this.ranges[i]+'"><a href="#" class=" "><span>Within '+this.ranges[i]+' Miles</span></a></li>';
			}
			$container.innerHTML = html;

			$container.querySelectorAll('.checkbox').forEach(function (link) {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					let wasChecked = link.classList.contains('checked');
					$container.querySelectorAll('.checkbox').forEach(function (l) {
						l.classList.remove('checked');
					});
					if(!wasChecked){
						link.classList.add('checked');
						args.helper.setQueryParameter('aroundRadius', parseInt(e.currentTarget.dataset.radius*1609.34));
					}else{
						args.helper.setQueryParameter('aroundRadius', 'all');
					}
					args.helper.search();
				});
			});
		},

		render: function (args) {
			let _local = this;
			if (args.state.query !== "" && this.lastGeoQuery !== args.state.query) {
				try{
					// let geocoder = new google.maps.Geocoder();
					// geocoder.geocode({ 'address': args.state.query }, function (results, status) {
					// 	if (status == 'OK') {
					// 		console.log(results[0].geometry.location.lat()+", "+results[0].geometry.location.lng());
					// 		_local.lastGeoLocation = results[0].geometry.location.lat()+", "+results[0].geometry.location.lng();
					// 		args.helper.setQueryParameter('query', "");
					// 		console.log(args.renderState["locations"].refinementList["_geoloc.lat"]);
					// 		// console.log(args.renderState.refinementList["_geoloc.lat"].refine(results[0].geometry.location.lat()));
					// 		//.refinementList
					// 		args.helper.setQueryParameter('aroundLatLng', _local.lastGeoLocation);
					// 	} else {
					// 		console.log('Geocode was not successful for the following reason: ', status, results);
					// 	}
					// 	_local.lastGeoQuery = args.state.query;
					// });
				}catch(e){
					console.log(e);
				}
			}
		}
	};
};
